import React from 'react'
import styles from './RecommendationCard.module.css'

const RecommendationCard = ({ 
  title, 
  subtitle, 
  description, 
  content, 
  progress,
  color,
  textColor, 
  icon 
}) => {
  return (
    <div 
      className={styles.recommendationCard}
      style={{ background: color, color: textColor }}
    >
      <div className={styles.cardHeader}>
        <h4 className={styles.cardTitle}>{title}</h4>
        <div className={styles.cardIcon}>
          {icon}
        </div>
        
      </div>

      <p className={styles.cardSubtitle}>{subtitle}</p>
      
      <div className={styles.cardContent}>
        
        <div className={styles.cardDescription}>
          <p>"{description}"</p>
          <p className={styles.cardMeta}>{content}</p>
        </div>

        {progress && (
          <div className={styles.progressContainer}>
            <div className={styles.progressBar}>
              <div 
                className={styles.progressFill}
                style={{ width: `${(parseInt(progress.split('/')[0]) / parseInt(progress.split('/')[1])) * 100}%` }}
              ></div>
            </div>
            <span className={styles.progressText}>{progress}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default RecommendationCard